import { ActionsObservable } from 'redux-observable';
import { Store } from 'redux';
import { escapeRegExp } from 'lodash';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/timeout';
import {
  SearchMessageRequest,
  searchMessageSuccess,
  AppAction,
} from '../actions';
import { SEARCH_MESSAGE_REQUEST } from '../constants';
import { Message, Messages, AppState } from '../models';
import { AjaxCreationMethod } from 'rxjs/observable/dom/AjaxObservable';

const searchMessageObservable = (text: string, messages: Messages): Observable<Messages> => {
  if (text) {
    const re = new RegExp(escapeRegExp(text), 'i');
    const isMatch = (message: Message) => re.test(message.text);
    const searchedMessages = messages.filter(isMatch);
    return Observable.of(searchedMessages).timeout(50);
  }
  return Observable.of(messages);
};

export const searchMessage = (action$: ActionsObservable<AppAction>,
                              store: Store<AppState>,
                              ajax: AjaxCreationMethod): Observable<AppAction> => {

  return action$.ofType(SEARCH_MESSAGE_REQUEST)
    .mergeMap((request: SearchMessageRequest) => {
      return searchMessageObservable(request.text, store.getState().messageState.messages)
      .map((searchedMessages: Messages) => searchMessageSuccess(searchedMessages));
    });

};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/searchMessage.ts